// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.modality-card-module__card____zz_J {
  padding: 16px;
  color: var(--neutral100, #2c2e30);
  overflow: hidden;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  font-size: 0.875rem;
  text-align: start;
}
.modality-card-module__card-info___mkVXI {
  color: inherit;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.modality-card-module__card-grow___lCgQB {
  flex: 1;
}
html[class*=light-mode] .modality-card-module__card____zz_J {
  box-shadow: 8px 8px 40px rgba(var(--neutral100-rgb, 44, 46, 48), 0.1);
}
.modality-card-module__card____zz_J p {
  margin: 0;
}
.modality-card-module__card____zz_J h3 {
  font-weight: 500;
  font-size: 1rem;
}
.modality-card-module__card-surface___t5ZQ7 {
  color: var(--neutral100, #2c2e30);
  background-color: var(--surface1, #fff);
}
.modality-card-module__card-primary___ETQr9 {
  background-color: var(--primary600, #4b286d);
  color: var(--surface1, #fff);
}
.modality-card-module__card-primary200___sDTag {
  background-color: var(--primary200, #d8cbe5);
}
.modality-card-module__card-plain___yGgns {
  color: var(--neutral100, #2c2e30);
  border: 1px solid var(--neutral30, #e3e6e8);
  background-color: var(--surface1, #fff);
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./client/app/react-components/modalities/modality-card/modality-card.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_theme.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AAMF;AAJE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAMJ;AAHE;EACE,OAAA;AAKJ;ACpBE;EDmBE,qEAAA;AAIJ;AADE;EACE,SAAA;AAGJ;AAAE;EACE,gBAAA;EACA,eAAA;AAEJ;AACE;EACE,iCAAA;EACA,uCAAA;AACJ;AAEE;EACE,4CAAA;EACA,4BAAA;AAAJ;AAGE;EACE,4CAAA;AADJ;AAIE;EACE,iCAAA;EACA,2CAAA;EACA,uCAAA;EACA,2BAAA;AAFJ","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '~wa-storybook/styles/utils';\n\n.card {\n  padding: 16px;\n  color: color(neutral100);\n  overflow: hidden;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  font-size: rem(14);\n  text-align: start;\n\n  &-info {\n    color: inherit;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &-grow {\n    flex: 1;\n  }\n\n  @include light {\n    box-shadow: 8px 8px 40px rgba(color(neutral100, true), 0.1);\n  }\n\n  p {\n    margin: 0;\n  }\n\n  h3 {\n    font-weight: 500;\n    font-size: rem(16);\n  }\n\n  &-surface {\n    color: color(neutral100);\n    background-color: color(surface1);\n  }\n\n  &-primary {\n    background-color: color(primary600);\n    color: color(surface1);\n  }\n\n  &-primary200 {\n    background-color: color(primary200);\n  }\n\n  &-plain {\n    color: color(neutral100);\n    border: 1px solid color(neutral30);\n    background-color: color(surface1);\n    box-shadow: none !important;\n  }\n\n}\n","//  Mixins to easily add style for light / dark modes only\n//\n//  Example: Let's say you need to add a shadow only for the light mode\n//      @include light {\n//          box-shadow: 8px 8px 40px #000000;\n//      }\n\n@mixin light {\n  html[class*='light-mode'] & {\n    @content;\n  }\n}\n\n@mixin dark {\n  html[class*='dark-mode'] & {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `modality-card-module__card____zz_J`,
	"card-info": `modality-card-module__card-info___mkVXI`,
	"card-grow": `modality-card-module__card-grow___lCgQB`,
	"card-surface": `modality-card-module__card-surface___t5ZQ7`,
	"card-primary": `modality-card-module__card-primary___ETQr9`,
	"card-primary200": `modality-card-module__card-primary200___sDTag`,
	"card-plain": `modality-card-module__card-plain___yGgns`
};
export default ___CSS_LOADER_EXPORT___;
